import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormHelperText,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { ClioTasksInfo, UsersModel } from "../../api";
import { useEffect, useState } from "react";

interface ClioTaskInfoDialogProps {
  task: ClioTasksInfo;
  onClose: () => void;
  onSave: (updatedTask: ClioTasksInfo) => void;
  users: UsersModel[];
}

export default function ClioTaskInfoDialog({
  task,
  onClose,
  onSave,
  users,
}: ClioTaskInfoDialogProps) {
  const [formTask, setFormTask] = useState<ClioTasksInfo>(task);

  useEffect(() => {
    setFormTask(task);
  }, [task])

  const handleChange = (field: keyof ClioTasksInfo, value: any) => {
    setFormTask((prev) => (prev ? { ...prev, [field]: value } : prev));
  };

  const handleSave = () => {
    onSave(formTask)
  }

  return (
    <Dialog open={!!formTask} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Edit Task #{formTask.id}</DialogTitle>
      <DialogContent dividers>
        <div className="row mt-2">
          <div className="col-md-12 mb-3">
            <TextField
              fullWidth
              label="Name"
              variant="outlined"
              value={formTask.name || ""}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </div>

          <div className="col-md-6 mb-3">
            <TextField
              fullWidth
              label="Due Days"
              variant="outlined"
              type="number"
              value={formTask.dueDays || ""}
              onChange={(e) => handleChange("dueDays", +e.target.value)}
            />
          </div>

          
          {/* ✅ isCalendarDate Checkbox */}
          <div className="col-md-6 mb-3">
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!formTask.isCalendarDate}
                  onChange={(e) =>
                    handleChange("isCalendarDate", e.target.checked)
                  }
                />
              }
              label="Calendar Date"
            />
          </div>

          <div className="col-12 mb-3">
            <TextField
              fullWidth
              label="Description"
              variant="outlined"
              multiline
              minRows={2}
              value={formTask.description || ""}
              onChange={(e) => handleChange("description", e.target.value)}
            />
          </div>

          {/* 👇 New Assignee Dropdown */}
          <div className="col-md-6 mb-3">
            <FormControl fullWidth>
              <InputLabel>Assignee</InputLabel>
              <Select
                label="Assignee"
                value={formTask.assignee || ""}
                onChange={(e) => handleChange("assignee", e.target.value)}
                sx={{ textAlign: "left" }}
              >
                <MenuItem key="None" value="">
                  None
                </MenuItem>
                <MenuItem key="RAA" value="RAA">
                  RAA
                </MenuItem>
                <MenuItem key="AP" value="AP">
                  AP
                </MenuItem>
                <MenuItem key="ALA" value="ALA">
                  ALA
                </MenuItem>
                {users.map((user) => (
                  <MenuItem key={user.id} value={user.name ?? ""}>
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
